// MUI
import { Button, Stack } from "@mui/material";

// Types
import { AuthRoleStatus } from "@Settings/types/administrationTools/utils";
import { CapitalizedRoles } from "@Settings/types/Common/auth";

type DoubleButtonLoginProps = Readonly<{
	authRoleStatuses: AuthRoleStatus[] | undefined;
	// Callbacks
	onLogin: (role: CapitalizedRoles) => void;
	onLogout: (role: CapitalizedRoles) => void;
}>;

export default function MultipleRoleLogin(props: DoubleButtonLoginProps) {
	const { authRoleStatuses = [] } = props;

	if (!authRoleStatuses.length) {
		return null;
	}

	return (
		<Stack spacing={2} component={"ul"} mt={2}>
			{authRoleStatuses.map((authRoleStatus) => {
				return (
					<Button
						key={authRoleStatus.role}
						variant={"contained"}
						type={authRoleStatus?.isLoggedIn ? "button" : "submit"}
						disableElevation
						classes={{
							root: `!font-sans !font-normal !text-sm !rounded-[6px] !capitalize !h-[30px] ${
								authRoleStatus.isLoggedIn ? "!bg-[#585B6D]" : "!bg-primary"
							} `,
						}}
						// Callbacks
						onClick={() =>
							authRoleStatus.isLoggedIn ? props.onLogout(authRoleStatus.role) : props.onLogin(authRoleStatus.role)
						}
					>
						{authRoleStatus.role} {authRoleStatus.isLoggedIn ? "Log out" : "Log In"}
					</Button>
				);
			})}
		</Stack>
	);
}
